export const DASHBOARD_TABS = [
  { key: 'activeAccounts', label: 'Active Accounts' },
  { key: 'adminAccess', label: 'Admin Access', adminOnly: true },
  { key: 'agencyAnalytics', label: 'Agency Analytics' },
  { key: 'aiReelCreator', label: 'AI Reel Creator' },
  { key: 'cyprus', label: 'Cyprus Relocation' },
  { key: 'dataConnections', label: 'Data Connections' },
  { key: 'accounts', label: 'Management Accounts' },
  { key: 'marketing', label: 'Marketing Analytics' },
  { key: 'reelInsights', label: 'Reel Virality Checker' },
  { key: 'revenue', label: 'Revenue' },
  { key: 'savings', label: 'Savings Goal' },
  { key: 'spending', label: 'Spending (Avg)' },
  { key: 'subscribers', label: 'Subscribers' }
];

export const AGENCY_VIEWER_TABS = ['agencyAnalytics'];
export const MODEL_TABS = DASHBOARD_TABS.filter((tab) => tab.key !== 'adminAccess').map((tab) => tab.key);
export const ADMIN_TABS = DASHBOARD_TABS.map((tab) => tab.key);

const tabKeys = new Set(DASHBOARD_TABS.map((tab) => tab.key));

export const getTabLabel = (tabKey) => {
  const tab = DASHBOARD_TABS.find((item) => item.key === tabKey);
  return tab?.label || tabKey.charAt(0).toUpperCase() + tabKey.slice(1);
};

export const getDefaultTabsForRole = (role) => {
  if (role === 'admin' || role === 'internal') return ADMIN_TABS;
  if (role === 'model') return MODEL_TABS;
  return AGENCY_VIEWER_TABS;
};

export const sanitizeTabsForRole = (tabs, role) => {
  const allowedTabs = role === 'admin' || role === 'internal'
    ? ADMIN_TABS
    : ADMIN_TABS.filter((tabKey) => tabKey !== 'adminAccess');
  const uniqueTabs = Array.from(new Set((tabs || []).filter((tabKey) => tabKeys.has(tabKey))));
  const sanitizedTabs = ADMIN_TABS.filter((tabKey) => uniqueTabs.includes(tabKey) && allowedTabs.includes(tabKey));
  return sanitizedTabs.length ? sanitizedTabs : AGENCY_VIEWER_TABS;
};

export const getVisibleTabsForProfile = (profile) => {
  if (!profile) return AGENCY_VIEWER_TABS;
  const defaultTabs = getDefaultTabsForRole(profile.role);
  const customTabs = Array.isArray(profile.tabs) ? profile.tabs : [];
  const requestedTabs = customTabs.length ? [...customTabs] : [...defaultTabs];
  if (['admin', 'internal', 'model'].includes(profile.role)) {
    ['activeAccounts', 'aiReelCreator', 'dataConnections'].forEach((requiredTab) => {
      if (!requestedTabs.includes(requiredTab)) requestedTabs.push(requiredTab);
    });
  }
  return sanitizeTabsForRole(requestedTabs, profile.role);
};
